<template>
  <nav class="hc-utility-nav" aria-label="Language Navigation Bar">
    <ul class="hc-utility-nav__container">
      <div class="container">
        <li class="hc-utility-nav__item" @click="goHistory">
          <a class="history" href="javascript:void(0)">{{
            $t("navUtili.jobHistory")
            }}</a>
        </li>
        <li class="hc-utility-nav__item">
          <span style="color: #fff; font-size: 0.85rem;">{{ $t("navUtili.language") }}</span>
          <div class="wpml-ls-statics-shortcode_actions wpml-ls wpml-ls-legacy-dropdown js-wpml-ls-legacy-dropdown">
            <ul>
              <li
                class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-en wpml-ls-current-language wpml-ls-item-legacy-dropdown">
                <a href="#" class="js-wpml-ls-item-toggle wpml-ls-item-toggle">
                  <span class="wpml-ls-native">{{ $t("navUtili.lang") }}</span></a>
                <ul class="wpml-ls-sub-menu">
                  <li class="wpml-ls-slot-shortcode_actions wpml-ls-item" @click="changeLang('cn')">
                    <a href="#" class="wpml-ls-link">
                      <span class="wpml-ls-display">中文</span></a>
                  </li>
                  <li class="wpml-ls-slot-shortcode_actions wpml-ls-item" @click="changeLang('en')">
                    <a href="#" class="wpml-ls-link">
                      <span class="wpml-ls-display">English</span></a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </li>
      </div>
    </ul>
  </nav>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();

const changeLang =(lang) =>{
  localStorage.setItem('language', lang)
    locale.value = lang;
}
const goHistory =()=>{
  let lang = ''
  if(locale.value === 'en'){
    lang="en_US"
  }else {
    lang = "zh_CN"
  }
  window.location.href = import.meta.env.VITE_APP_APP_HISTORY+'?lang='+ lang
}

</script>

<style lang="scss" scoped>
.hc-utility-nav__container{
     width: 100%;
        background-color: var(--hc-color--darkblue);
        color: var(--hc-color--darkblue);
        .container{
            width: 100%;
            max-width: 1426px;
            margin: 0 auto;
            display: flex;
            align-items: center;
              justify-content: flex-end;
              gap: 40px;
        }
}
.hc-utility-nav__item .history:focus,
.hc-utility-nav__item .history:hover {
  text-decoration: underline
}
</style>
